import useGetExaminations from './useGetExaminations';

export default useGetExaminations;
